// extracted by mini-css-extract-plugin
module.exports = {"testWrapper":"TestLinks_testWrapper__XqW44","info":"TestLinks_info__30B8G","response":"TestLinks_response__3pS2i"};